// routes
import { PATH_DASHBOARD, MULTI_CHANNEL, PATH_CONTACT, PATH_SERVICES, PATH_PBX, PATH_TICKET, PATH_CONFIGURATION,PATH_STATISTIC } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';
import { Icon } from '@iconify/react';
import ForumIcon from '@mui/icons-material/Forum';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ListIcon from '@mui/icons-material/List';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import PeopleIcon from '@mui/icons-material/People';
import InsightsIcon from '@mui/icons-material/Insights';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  facebook: getIcon('ic_facebook'),
  zalo: getIcon('ic_zalo'),
  messenger: getIcon('ic_messenger'),
  chat_zalo: getIcon('ic_chat_zalo'),
  live_chat:getIcon('ic_livechat')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'app',
  //       path: PATH_DASHBOARD.general.app,
  //       icon: ICONS.dashboard
  //     },
  //     { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
  //     { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
  //     { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
  //     { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking }
  //   ]
  // },

  // // MANAGEMENT
  // // ----------------------------------------------------------------------
  // {
  //   subheader: 'management',
  //   items: [
  //     // MANAGEMENT : USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.newUser },
  //         { title: 'edit', path: PATH_DASHBOARD.user.editById },
  //         { title: 'account', path: PATH_DASHBOARD.user.account }
  //       ]
  //     },

  //     // MANAGEMENT : E-COMMERCE
  //     {
  //       title: 'e-commerce',
  //       path: PATH_DASHBOARD.eCommerce.root,
  //       icon: ICONS.cart,
  //       children: [
  //         { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //         { title: 'product', path: PATH_DASHBOARD.eCommerce.productById },
  //         { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //         { title: 'create', path: PATH_DASHBOARD.eCommerce.newProduct },
  //         { title: 'edit', path: PATH_DASHBOARD.eCommerce.editById },
  //         { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //         { title: 'invoice', path: PATH_DASHBOARD.eCommerce.invoice }
  //       ]
  //     },

  //     // MANAGEMENT : BLOG
  //     {
  //       title: 'blog',
  //       path: PATH_DASHBOARD.blog.root,
  //       icon: ICONS.blog,
  //       children: [
  //         { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //         { title: 'post', path: PATH_DASHBOARD.blog.postById },
  //         { title: 'new post', path: PATH_DASHBOARD.blog.newPost }
  //       ]
  //     }
  //   ]
  // },

  // APP
  // ----------------------------------------------------------------------
  {
    subheader: "Đa kênh",
    // icon: <ForumIcon />,
    icon: <SvgIconStyle src={`/static/Omnichannel.svg`} sx={{ width: 25, height: 25 }}/>,
    items: [
      // {
      //   title: 'status',
      //   path: MULTI_CHANNEL.facebook.status,
      //   icon: ICONS.mail,
      //   info: <Label color="error">2</Label>
      // },
      // { title: 'Live Chat', path: MULTI_CHANNEL.live_chat.chat, icon: ICONS.live_chat },
      // { title: 'Posts', path: MULTI_CHANNEL.facebook.pages, icon:<Icon icon="gg:feed" width="22px"/> },
      { title: 'Messenger', path: MULTI_CHANNEL.facebook.chat, icon: ICONS.messenger },
      { title: 'Zalo Chat', path: MULTI_CHANNEL.zalo.chat, icon: ICONS.chat_zalo },
      { title: 'SMS/ZNS', path: PATH_SERVICES.services.smszns, icon: <Icon icon="fa6-solid:comment-sms" width="22px"/>}
      // {
      //   title: 'kanban',
      //   path: PATH_DASHBOARD.kanban,
      //   icon: ICONS.kanban
      // }
    ]
  },
  // {
  //   subheader: "Đa kênh",
  //   items: [
     
  //     {
  //       title: 'facebook',
  //       path: MULTI_CHANNEL.facebook.root,
  //       icon: ICONS.chat,
  //       info: <Label color="error">2</Label>,
  //       children: [
  //         { title: 'chat', path: MULTI_CHANNEL.facebook.chat, icon: ICONS.chat, info: <Label color="error">2</Label> },
  //         { title: 'setting', path: MULTI_CHANNEL.facebook.setting, icon: <i className="fa fa-cog" aria-hidden="true"></i> },
  //       ]
  //     },
  //     {
  //       title: 'zalo',
  //       path: MULTI_CHANNEL.zalo.root,
  //       icon: <i className="fa fa-cog" aria-hidden="true"></i>,
  //       children: [
  //         { title: 'chat', path: MULTI_CHANNEL.zalo.chat, icon: ICONS.chat },
  //         { title: 'setting', path: MULTI_CHANNEL.zalo.setting, icon: <i className="fa fa-cog" aria-hidden="true"></i> },
  //       ]
  //     },
    
  //   ]
  // },
  {
    subheader: "Quản lí",
    icon: <ManageAccountsIcon />,
    items: [
      // {
      //   title: 'mail',
      //   path: PATH_DASHBOARD.mail.root,
      //   icon: ICONS.mail,
      //   info: <Label color="error">2</Label>
      // },
      // { title: 'Nhân viên', path: PATH_CONTACT.contact.staff, icon: <PeopleIcon /> },
      { title: 'Khách hàng', path: PATH_CONTACT.contact.contactlist, icon: <Icon icon="ri:customer-service-2-line" width="22px"/> },
      { title: 'Phiếu ghi', path: PATH_TICKET.ticket.list, icon: <LocalActivityIcon /> }
      // { title: 'setting', path: MULTI_CHANNEL.zalo.setting, icon: <i className="fa fa-cog" aria-hidden="true"></i> },
      // { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
      // {
      //   title: 'kanban',
      //   path: PATH_DASHBOARD.kanban,
      //   icon: ICONS.kanban
      // }
    ]
  },
  // {
  //   subheader: "Dịch vụ",
  //   icon: <BusinessCenterIcon />,
  //   items: [
  //     { title: 'SMS/ZNS', path: PATH_SERVICES.services.smszns, icon: <i className="fas fa-sms" aria-hidden="true" sx={{ width: '100%', height: '100%' }}></i> }
  //   ]
  // },
  {
    subheader: "Thống kê & Báo cáo",
    icon: <Icon icon="wpf:statistics" width="22px"/>,
    items: [
      { title: 'Lịch sử cuộc gọi', path: PATH_PBX.pbx.callhistory, icon: <Icon icon="material-symbols:call-log-rounded" width="30" height="30"></Icon> }
    ]
  },
  // {
  //   subheader: "Thống kê",
  //   icon: <InsightsIcon />,
  //   path: PATH_STATISTIC.root,
  //   items:[]
  //   // items: [
  //   //   { title: 'Hệ thống', path: PATH_CONFIGURATION.root, icon: <SettingsSuggestIcon /> }
  //   // ]
  // },
  {
    subheader: "Cài đặt",
    icon: <SettingsIcon />,
    path: PATH_CONFIGURATION.root,
    items:[]
    // items: [
    //   { title: 'Hệ thống', path: PATH_CONFIGURATION.root, icon: <SettingsSuggestIcon /> }
    // ]
  }
];

export default sidebarConfig;
